import { areaAttendeeRestrictionConflictsMessage } from "./areaRestriction"

export function confirmableAssignmentUpdate({ area, attendee, onConfirm, onCancel }) {
  const conflictsMessage = areaAttendeeRestrictionConflictsMessage({ area, attendee })

  if (conflictsMessage) {
    return alertModal(
      {
        title: "Override area restrictions?",
        text: conflictsMessage,
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "Nevermind",
        confirmButtonText: "Yes, assign",
        closeOnConfirm: true
      },
      onConfirm,
      onCancel
    )
  } else {
    return onConfirm()
  }
}
